import React from 'react';

const Redirect404 = () => {
    window.location.href = 'https://viewlogies.com/404';
    return null;
};

export default Redirect404;
